import { Outlet } from "react-router-dom"
import Sidebar from './Sidebar'
import classes from './Home.module.scss'
import { useLocation } from 'react-router-dom';

const SidebarLessRoutes = [
  '/assessment/document_review/instructions',
  '/assessment/document_review/practice',
  '/assessment/document_review/begin',
  '/assessment/cyber/instructions',
  '/assessment/cyber/begin'
]

const Home = () => {
  let location = useLocation()

  const isSidebarRequired = () => !SidebarLessRoutes.includes(location.pathname)

  return (
    <div className={classes.dashboard_container}>
     {isSidebarRequired() && <Sidebar />}
      <div className={classes.content_container}>
        <Outlet />
      </div>
    </div>
  )
}

export default Home
